import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ApparatusListComponent} from './apparatus-list/apparatus-list.component';
import {ApparatusViewComponent} from './apparatus-view/apparatus-view.component';
import {ApparatusCardComponent} from './apparatus-card-form/apparatus-card.component';
import {ApparatusCardResolverService} from './services/apparatus-card-resolver.service';
import {MethodsResolverService} from '@providers/_resolvers/methods-resolver.service';
import {EquipmentPagesResolverService} from './services/equipment-pages/equipment-pages-resolver.service';
import {EquipmentPagesResetOnDeactivateService} from './services/equipment-pages/equipment-pages-reset-on-deactivate.service';

export const apparatusModuleRoutes: Routes = [
    {
        path: '',
        canDeactivate: [
            EquipmentPagesResetOnDeactivateService
        ],
        children: [
            {path: 'index', redirectTo: '', pathMatch: 'full'},
            {
                path: '',
                component: ApparatusListComponent,
                data: {title: 'Оборудование'},
                resolve: {
                    items: EquipmentPagesResolverService,
                    methods: MethodsResolverService
                }
            },
            {path: 'view', redirectTo: 'index'},
            {
                path: 'view/:id',
                component: ApparatusViewComponent,
                data: {title: 'Просмотр оборудования'},
                resolve: {
                    apparatus: ApparatusCardResolverService
                }
            },
            {path: 'form', redirectTo: 'new'},
            {
                path: 'new',
                component: ApparatusCardComponent,
                data: {title: 'Создание оборудования'},
            },
            {path: 'edit', redirectTo: 'index'},
            {
                path: 'edit/:id',
                component: ApparatusCardComponent,
                data: {title: 'Редактирование оборудования'},
                resolve: {
                    formValues: ApparatusCardResolverService
                }
            },
        ]
    },
];

@NgModule({
    imports: [
        RouterModule.forChild(apparatusModuleRoutes)
    ],
    exports: [
        RouterModule
    ]
})
export class ApparatusRoutingModule {
}
